import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { AppUtils } from '../../utils/app.utils';

@Pipe({
  name: 'formatTime',
  standalone: false,
})
export class FormatTimePipe implements PipeTransform {
  private readonly datePipe: DatePipe = inject(DatePipe);

  transform(date?: Date | string): string {
    const defaultTimeFormat: string = 'HH:mm';
    const timeFormat: string = environment.stores.find(
      store => store.storeId === AppUtils.getCurrentStore().storeId
    )?.timeFormat ?? defaultTimeFormat;

    date = (typeof date === 'string') ? new Date(date) : date;

    return this.datePipe.transform(date, timeFormat) || '';
  }
}
